import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ManagerContractService {
  constructor(public _httpClient: HttpClient) {}

  async getManagerContract(type: string) {
    return this._httpClient
      .get('/get-contract/' + type)
      .toPromise()
      .then((response: any) => {
        return response.content;
      });
  }

  async updateManagerContract(contract_type: string, data: any) {
    return this._httpClient.put(`/update-file/contracts/${contract_type}`, data).toPromise();
  }
}
